var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"editor",staticClass:"minEditorHeight",attrs:{"contenteditable":!_vm.readonly},on:{"keydown":_vm.onKeyDown,"input":_vm.onInput}}),_c('small',{ref:"errorDiv",staticClass:"form-text text-muted"})])}
var staticRenderFns = []

export { render, staticRenderFns }